import { db, storage } from '../firebase';
import {
    collection,
    getDocs,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    query,
    orderBy
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

const BANNERS_COLLECTION = 'banners';

export const getAllBanners = async () => {
    const q = query(collection(db, BANNERS_COLLECTION), orderBy('sequence', 'asc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const addBanner = async (bannerData, imageFile) => {
    let imageUrl = '';
    if (imageFile) {
        const storageRef = ref(storage, `banners/${Date.now()}_${imageFile.name}`);
        await uploadBytes(storageRef, imageFile);
        imageUrl = await getDownloadURL(storageRef);
    }

    return await addDoc(collection(db, BANNERS_COLLECTION), {
        ...bannerData,
        imageUrl,
        createdAt: new Date().toISOString()
    });
};

export const updateBanner = async (bannerId, bannerData, newImageFile) => {
    let imageUrl = bannerData.imageUrl;

    if (newImageFile) {
        // Optional: Delete old image if it exists in storage
        const storageRef = ref(storage, `banners/${Date.now()}_${newImageFile.name}`);
        await uploadBytes(storageRef, newImageFile);
        imageUrl = await getDownloadURL(storageRef);
    }

    const bannerRef = doc(db, BANNERS_COLLECTION, bannerId);
    return await updateDoc(bannerRef, {
        ...bannerData,
        imageUrl,
        updatedAt: new Date().toISOString()
    });
};

export const deleteBanner = async (bannerId, imageUrl) => {
    // Delete from Firestore
    await deleteDoc(doc(db, BANNERS_COLLECTION, bannerId));

    // Delete from Storage if exists
    if (imageUrl) {
        try {
            const imageRef = ref(storage, imageUrl);
            await deleteObject(imageRef);
        } catch (error) {
            console.error('Error deleting image from storage:', error);
        }
    }
};
